import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FC } from "react";

interface SelectInput {
  label?: string;
  labelInput: string;
  value?: unknown;
  handleChange?: any;
  id: string;
  labelId?: string;
  data?: any;
  disabled?: any;
}

export default function BasicSelect({
  label,
  labelInput,
  value,
  handleChange,
  id,
  data,
  labelId,
  disabled
}: SelectInput) {
  //   const handleChange = (event: SelectChangeEvent) => {
  //     setAge(event.target.value as string);
  //   };

  return (
    <FormControl fullWidth sx={{m: 2}}>
      <InputLabel id="demo-simple-select-label">{label}</InputLabel>
      <Select
        fullWidth
      disabled={disabled}
        labelId={labelId}
        id={id}
        value={value}
        label={labelInput}
        onChange={handleChange}
        
      >
        {data &&
          data?.map(
            (
              item: any,
              index: any, // Correct map usage and added key
            ) => (
              <MenuItem key={item.value || index} value={item.value}>
                {item.label}
              </MenuItem>
            ),
          )}
      </Select>
    </FormControl>
  );
}
